import React, { useEffect, useRef, useState } from "react";
import { motion, useMotionValue, useAnimation, useTransform } from "framer-motion";
import "./FivePillars.css";
import pillar1 from '../../assets/pillar1.png';
import pillar2 from '../../assets/pillar2.png';
import pillar3 from '../../assets/pillar3.png';
import pillar4 from '../../assets/pillar4.png';
import pillar5 from '../../assets/pillar5.png';

const pillars = [
    {
        title: "Ambition and Vision",
        image: pillar1,
    },
    {
        title: "Belief, Ethics and Values",
        image:pillar2,
    },
    {
        title: "Intelligence/the Wisdom",
        image:pillar3
    },
    {
        title: "Psychological Wellbeing",
        image:pillar4,
    },
    {
        title: "Health, Discipline, and Leisure",
        image:pillar5,
    },
    {
        title: "Ambition and Vision",
        image: pillar1,
    },
    {
        title: "Belief, Ethics and Values",
        image:pillar2,
    },
    {
        title: "Intelligence/the Wisdom",
        image:pillar3
    },
    {
        title: "Psychological Wellbeing",
        image:pillar4,
    },
    {
        title: "Health, Discipline, and Leisure",
        image:pillar5,
    }
];

const FivePillars = () => {
    const [isScreenSizeSm, setIsScreenSizeSm] = useState(window.innerWidth <= 640);
    const cylinderWidth = isScreenSizeSm ? 1100 : 2200;
    const faceCount = pillars.length;
    const faceWidth = (cylinderWidth / faceCount) * 1.5; // Increased width for items
    const dragFactor = 0.01;
    const radius = cylinderWidth / (2 * Math.PI);
    const rotation = useMotionValue(0);
    const controls = useAnimation();

    const handleDrag = (_, info) => {
        rotation.set(rotation.get() + info.offset.x * dragFactor);
    };

    const handleDragEnd = (_, info) => {
        controls.start({
            rotateY: rotation.get() + info.velocity.x * dragFactor,
            transition: { type: "spring", stiffness: 60, damping: 20, mass: 0.1, ease: "easeOut" },
        });
    };

    const transform = useTransform(rotation, (value) => {
        return `rotateY(${value}deg)`;
    });

    useEffect(() => {
        const handleResize = () => {
            setIsScreenSizeSm(window.innerWidth <= 640);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            rotation.set(rotation.get() + 0.5); // Adjust the rotation speed here
        }, 50); // Adjust the interval time here

        return () => clearInterval(interval);
    }, [rotation]);

    return (
        <section id="pillars-section" className="pillars-section">
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, margin: "0px 0px -100px 0px" }}
                transition={{ duration: 0.1 }}
                className="pillars-content"
            >
                <h2>UNIAARIV’s Five Pillars Assessment Approach</h2>
                <div className="gallery-container">
                    <div className="gallery-gradient gallery-gradient-left"></div>
                    <div className="gallery-gradient gallery-gradient-right"></div>
                    <div className="gallery-content">
                        <motion.div
                            drag="x"
                            className="gallery-track"
                            style={{
                                transform: transform,
                                rotateY: rotation,
                                width: cylinderWidth,
                                transformStyle: "preserve-3d",
                            }}
                            onDrag={handleDrag}
                            onDragEnd={handleDragEnd}
                            animate={controls}
                        >
                            {pillars.map((pillar, i) => (
                                <div
                                    key={i}
                                    className="gallery-item"
                                    style={{
                                        width: `${faceWidth}px`,
                                        transform: `rotateY(${i * (360 / faceCount)}deg) translateZ(${radius}px)`,
                                    }}
                                >
                                    <div className="pillar-card">
                                        <div
                                            className="pillar-image"
                                            style={{ backgroundImage: `url(${pillar.image})` }}
                                        />
                                        <div className="pillar-content">
                                            <h3>{pillar.title}</h3>
                                            <div className="pillar-line" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </motion.div>
                    </div>
                </div>
                <p className="pillars-description">
                    Our proprietary Five Pillars Assessment Approach and TrueIN Assessment Tool © factor in
                    the root cause which influence health, behaviour, ethical and performance aspects therefore
                    the Assessment is very Precise, Unbiased and Holistic.
                </p>
            </motion.div>
        </section>
    );
};

export default FivePillars;